import { Button, Upload } from 'antd';
import { UploadOutlined } from '@ant-design/icons';

function TestUpload(props) {

    const processFile = async file => {

        let testData = [];

        const reader = new FileReader();
        reader.onload = async e => {
            const lines = e.target.result.split("\n");
            //console.log(lines);
            for (let i = 0; i < lines.length; i++) {
                const parts = lines[i].split('"');
                if (parts[5] !== undefined) {
                    const names = parts[5].trim().split(/\s+/);
                    //console.log(names);
                    //console.log(parts[1], names[0], names[1], parts[7]);
                    testData.push({
                        startGroup: parts[1],
                        association: parts[7],
                        firstName: names[1],
                        lastName: names[0]
                    });    
                }
            }
            await props.uploadTestData(testData);
        }
        reader.readAsText(file);

        return false;
    }

    return (
        <Upload
            beforeUpload={processFile}
            showUploadList={false}
        >
            <Button
                type="dashed"
                icon={<UploadOutlined />}
            >
                Test-Daten hochladen
            </Button>
        </Upload>
    );
}

export default TestUpload;